import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Box, Grid, Typography } from "@material-ui/core";
import { FruProButton } from "@components";
import {
  REGISTRATION_PROCCESS_STEPS,
  VERTIFICATION_METHOD_ENUM,
} from "../../../constants";
import { useSelector } from "react-redux";
import { AmptitudeEvents } from "@services/amptitude_events";
import {
  EMAIL_VERIFICATION_SELECTED,
  SMS_VERIFICATION_SELECTED,
} from "@services/amptitude_contants";
const useStyles = makeStyles((theme) => ({
  root: {
    background: "transparent",
    paddingLeft: 150,
  },
  selectVertification: {
    height: "auto",
    width: "450px",
    borderRadius: 20,
    background: "rgba(249, 249, 249, 0.9)",
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.05)",
    backdropFilter: "blur(15.5px)",
    padding: "20px 56px 40px",
  },
  bgImage: {
    background:
      "url('/static/images/backgrounds/login-banner.gif') center center no-repeat",
    backgroundSize: "cover",
    height: "100%",
  },
  title: {
    fontSize: 28,
    fontWeight: 500,
    color: "#E77228",

    marginBottom: 25,
  },
  customButton: {
    height: "60px !important",
    width: "100%",
    backgroundColor: "#69CDAE !important",
    borderRadius: "20px !important",
    border: "none !important",
  },
  customTransparentButton: {
    height: "60px !important",
    width: "100%",
    backgroundColor: "transparent !important",
    borderRadius: "20px !important",
    border: "1px solid #69CDAE !important",
  },
  bottomLabel: {
    fontSize: 16,
    color: "#636363",
    marginLeft: 10,
    marginTop: 20,
    "& .link-text": {
      color: theme.palette.primary.primaryA,
      fontWeight: 400,
      cursor: "pointer",
    },
  },
}));

export default function VertificationMethodSelection({
  onSelectVertificationMethod,
  setRegistrationStep,
  setIsEditProfile,
  onSendOTP,
  isLoading,
}) {
  const classes = useStyles();
  const user = useSelector((state) => state.auth.user);

  const onClickEmailButtonEvent = async () => {
    return await AmptitudeEvents("User Registration",user?.id, EMAIL_VERIFICATION_SELECTED);
  };
  const onClickSmsButtonEvent = async () => {
    return await AmptitudeEvents("User Registration",user?.id, SMS_VERIFICATION_SELECTED);
  };

  return (
    <Box className={classes.root} component="section">
      <Box className="row" height="100%">
        <Box className="col-4" padding={0}>
          <Box className={classes.selectVertification}>
            <Typography className={classes.title} align="center">
              Select your account verification method
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FruProButton
                  className={classes.customButton}
                  variant="outlined"
                  fontSize="20px"
                  fontWeight="500"
                  noMargin
                  onClick={() => {
                    onSelectVertificationMethod(
                      VERTIFICATION_METHOD_ENUM.EMAIL
                    );
                    onClickEmailButtonEvent();
                  }}
                  disabled={isLoading}
                >
                  E-mail
                </FruProButton>
              </Grid>
              <Grid item xs={12}>
                <FruProButton
                  className={classes.customTransparentButton}
                  variant="outlined"
                  color="green"
                  fontSize="20px"
                  fontWeight="500"
                  noMargin
                  onClick={() => {
                    onSendOTP(user);
                    onClickSmsButtonEvent();
                  }}
                  disabled={isLoading}
                >
                  SMS
                </FruProButton>
              </Grid>
            </Grid>
            <Typography className={classes.bottomLabel} align="start">
              Details incorrect?{" "}
              <span
                className="link-text"
                onClick={() => {
                  setRegistrationStep(REGISTRATION_PROCCESS_STEPS.step1);
                  setIsEditProfile(true);
                }}
              >
                Click here
              </span>{" "}
              to edit your details in registration page.
            </Typography>
          </Box>
        </Box>
        {/* <Box className="col-8" padding={0}>
          <Box className={classes.bgImage}></Box>
        </Box> */}
      </Box>
    </Box>
  );
}
